export class AssessTemp {
    Type;
    Grp;
    Item;
    CDesc;
    EDesc;
    AnsType;
    OptValue;
    constructor() {
        {
            this.Type = "";
            this.Grp = 0;
            this.Item = 0;
            this.CDesc = "";
            this.EDesc = "";
            this.AnsType = "Radio";
            this.OptValue = "";
        }
    }
}



// WEBPACK FOOTER //
// ./src/model/AssessTemp.js